import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

// This represents the "approval required" screener for invites, requiring them to be approved
// by an admin before they're sent out.
export default class ApprovalRequiredInviteAbility extends Ability {
  @service declare authz: AuthzService;

  get canReview(): boolean {
    const permission = Permission.VISITORS_INVITE_APPROVAL_REQUIRED_REVIEW;

    return this.authz.hasPermissionAtCurrentLocation(permission);
  }
}
